import { loc } from "../i18n/survey";

enum OtherPrograms {
  OnlineFitnessProgram = 'OnlineFitnessProgram',
  SelfGuidedFitnessProgram = 'SelfGuidedFitnessProgram',
  PersonalTrainer = 'PersonalTrainer',
  CalorieCounting = 'CalorieCounting',
  PaidMealPlans = 'PaidMealPlans',
  Keto = 'Keto',
  IntermittentFasting = 'IntermittentFasting',
}


const otherProgramsQuestion = {
  name: 'otherPrograms',
  title: loc("quiz.otherPrograms.title"),
  description: loc("quiz.otherPrograms.description"),
  type: 'checkbox',
  choices: [
    {
      value: OtherPrograms.OnlineFitnessProgram,
      text: loc("quiz.otherPrograms.choices.onlineProgram"),
    },
    {
      value: OtherPrograms.SelfGuidedFitnessProgram,
      text: loc("quiz.otherPrograms.choices.ownProgram"),
    },
    {
      value: OtherPrograms.PersonalTrainer,
      text: loc("quiz.otherPrograms.choices.personalTrainer"),
    },
    {
      value: OtherPrograms.CalorieCounting,
      text: loc("quiz.otherPrograms.choices.calorieCounting"),
    },
    {
      value: OtherPrograms.PaidMealPlans,
      text: loc("quiz.otherPrograms.choices.paidMealPlans"),
    },
    {
      value: OtherPrograms.Keto,
      text: loc("quiz.otherPrograms.choices.keto"),
    },
    {
      value: OtherPrograms.IntermittentFasting,
      text: loc("quiz.otherPrograms.choices.intermittentFasting"),
    },
  ],
  showNoneItem: true,
  // "None" agrees with a feminine noun in Spanish (lesión, restricción, opción).
  noneText: loc("quiz.shared.noneFeminine"),
  isRequired: true,
};

export {
  OtherPrograms,
  otherProgramsQuestion,
}